// extracted by mini-css-extract-plugin
export default {"energyIntroContainer":"energyIntro_energyIntroContainer__yGhMS","energyLeftColumn":"energyIntro_energyLeftColumn__-FsCl","energyRightColumn":"energyIntro_energyRightColumn__ypg-y"};